<div class="flex flex-col max-w-240 md:min-w-160 max-h-screen -m-6 dms-modal" 
    >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">Edit Description</div>
        <button
            mat-icon-button
            (click)="cancel()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form
        class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto"
        [formGroup]="editItemDescriptionForm">

        <!-- Item Name-->
        <mat-form-field class="no-select">
            <mat-label>Item Name</mat-label>
            <input
                matInput readonly 
                class="no-select"
                [formControlName]="'itemName'" [value]="'Untitled Folder'">
        </mat-form-field>

        <!-- Descripion -->
        <mat-label>Description</mat-label>
        <mat-form-field class="flex-auto">
            <textarea
                matInput
                [placeholder]="'About this item...'"
                [rows]="4"></textarea>
            <mat-icon
                class="icon-size-5"
                matPrefix
                [svgIcon]="'heroicons_solid:bars-3-bottom-left'"></mat-icon>
        </mat-form-field>

    </form>
</div>
